import { makeMainGEvent, pushEvent } from '../../../../utils/analytics';
import { Offer } from '../../Offer';
import styles from '../styles/Mite.module.scss';

export const Mite = () => {
  const handleClick = () => {
    pushEvent(
      makeMainGEvent({
        eventCategory: 'Клещ',
        eventAction: 'Сезонные предложения',
      }),
    );
  };

  return (
    <Offer
      title={'Страховка от укуса клеща'}
      subtitle="Действует по всей России с&nbsp;покрытием до&nbsp;2&nbsp;000&nbsp;000&nbsp;₽"
      color="green"
      href={'/strahovka-ot-klescha/?promoCode=ilovesravni'}
      badgeText="кешбэк 20%"
      linkText="Сравнить и выбрать"
      imageClassName={styles.picture}
      picture={[
        <source
          key="source-product-mite-png"
          srcSet={require('../images/img.png')}
          media={`(min-width: ${styles.breakpointTablet})`}
          type="image/webp"
        />,
        <img key="img-product-mite" src={require('../images/img_mob.png')} alt="" />,
      ]}
      onClick={handleClick}
    />
  );
};
